// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './active-customer.directive';
export * from './customer.module';
export * from './customer.store';
// @endindex